(() => {
function $185ee067a0fab524$var$initMenu() {
    const toggle = document.getElementById("menu-toggle");
    if (!toggle) return;
    const menu = document.getElementById(toggle.getAttribute("aria-controls"));
    if (!menu) return;
    const menuLinks = menu.querySelectorAll(":scope > ul > li > a");
    const body = document.body;
    const header = document.querySelector("header");
    const open = ()=>{
        body.classList.add("open");
        header?.classList.remove("header", "positive-header");
        menu.setAttribute("aria-hidden", "false");
        toggle.setAttribute("aria-expanded", "true");
        toggle.classList.add("is-active");
    };
    const close = ()=>{
        body.classList.remove("open");
        header?.classList.add("header");
        menu.setAttribute("aria-hidden", "true");
        toggle.setAttribute("aria-expanded", "false");
        toggle.classList.remove("is-active");
    };
    const handler = ()=>{
        if (menu.getAttribute("aria-hidden") === "true") open();
        else close();
    };
    toggle.addEventListener("click", handler);
    menuLinks.forEach((link)=>link.addEventListener("click", handler));
}
function $185ee067a0fab524$var$initLazyFade() {
    const targets = document.querySelectorAll(".lazyload");
    if (!targets.length) return;
    if (!("IntersectionObserver" in window)) {
        targets.forEach((el)=>el.classList.replace("lazyload", "lazyloaded"));
        return;
    }
    const io = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            entry.target.classList.replace("lazyload", "lazyloaded");
            observer.unobserve(entry.target);
        });
    }, {
        rootMargin: "200px"
    });
    targets.forEach((el)=>io.observe(el));
}
document.addEventListener("DOMContentLoaded", ()=>{
    $185ee067a0fab524$var$initMenu();
    $185ee067a0fab524$var$initLazyFade();
});

})();
//# sourceMappingURL=app.js.map
